export const namespace = "loader/";
export const SET_LOADED = `SET_LOADED`;
